import React, { memo } from 'react';

import { Label } from 'reaxl';

import ShowcaseSlot from './ShowcaseSlot';

function AllMediaThumbnailComponent({
    children,
    onClick = () => {},
}) {
    return (
        <div
            onClick={onClick}
            className="thumbnail-overlay inverse position-absolute display-flex align-items-center justify-content-center w-100 h-100 rounded padding-3 text-bold bg-dark-transparent-85"
            role="button"
            tabIndex={0}
        >
            {children}
        </div>
    );
}

export const AllMediaThumbnail = memo(AllMediaThumbnailComponent);

export function ClearThumbnail({
    currentDataSlot,
    isHideable,
}) {
    return (currentDataSlot && currentDataSlot.element) ? (
        <ShowcaseSlot
            hide={isHideable}
            onClick={currentDataSlot.onClick}
            className="secondary-slot"
        >
            {currentDataSlot.element}
            {currentDataSlot.badge
            && (
                <Label
                    bsStyle="inverse"
                    className="position-absolute text-size-100 margin-1"
                >
                    {`${currentDataSlot.badge || ''} (${(currentDataSlot.count)})`}
                </Label>
            )}
        </ShowcaseSlot>
    ) : <div />;
}

function OpaqueThumbnailComponent({
    currentDataSlot,
    allMediaTitle,
    onClick = () => {},
    ...rest
}) {
    return currentDataSlot && currentDataSlot.element ? (
        <ShowcaseSlot
            onClick={onClick}
            className="secondary-slot"
            {...rest}
        >
            {currentDataSlot.element}
            <AllMediaThumbnail>
                <p className="margin-0">{`${allMediaTitle}`}</p>
            </AllMediaThumbnail>
        </ShowcaseSlot>
    ) : <div />;
}

export const OpaqueThumbnail = memo(OpaqueThumbnailComponent);
